
const imageUrl = (title) => {
  return `/imgs/case/composite/${title}.png`;
};

const data = {
  introduce: {
    img: imageUrl('introduce'),
    title: '四流合一',
    description: '打造物流、商流、信息流、资金流“四流合一”的综合服务能力，通过供应链视角统领全局，致力于买卖双方之间交易效率的提升。'
  },
  method: imageUrl('method'),
  value: [
    {
      title: '提升效率',
      cols: ['项目名称', '系统价值点', '使用前', '使用后'],
      items: [
        ['人工下单', '订单协同', '750分钟', '5分钟'],
        ['人工调度', '实现智能化派单', '5分钟', '5分钟'],
        ['账单对账', '实现自动对账', '3天', '5分钟'],
        ['业务计费', '支持所有费用项\n自动计费', '700分钟', '15分钟'],
        ['运营分析', '提供数字化仪表盘', '48小时', '动态'],
      ]
    },
    {
      title: '降低成本',
      items: [
        {
          title: '管理成本、人工成本、交易成本、资金成本',
          description: '海格物流通过上线ePLD系统，实现年度管理费用下降30%。'
        }
      ]
    },
    {
      title: '全流程可视化',
      items: [
        {
          title: '流程可视化:',
          description: '业务由线下转到线上，流程更加透明化。'
        },
        {
          title: '管理可视化:',
          description: '管理者可掌握实时动态，异常事件响应更快。'
        },
        {
          title: '运营规范化:',
          description: '人员管理、业务流程、组织设计有序、合规。'
        }
      ]
    },
    {
      title: '共赢生态',
      items: [
        {
          title: '物流企业:',
          description: '获客能力增加，大客户数量年均增加20%；客户粘性强，5年以上客户占比90%。'
        },
        {
          title: '甲方企业:',
          description: '降低物流成本，实时掌握动态，提升客户满意度。'
        },
        {
          title: '供应商:',
          description: '货源稳定，市场份额增加。'
        },
        {
          title: '金融服务商:',
          description: '提高资金利用率，降低资金风险。'
        }
      ]
    },
  ]
};

export default data;


// WEBPACK FOOTER //
// ./src/routes/Case/config/composite.js